import { useQuery } from '@tanstack/react-query';
import type { VisitDetail } from '@munifocus/contracts-gov';
import { api } from './api-client';

/**
 * A file's visit check-ins, read-only on the desk portal: visits are recorded
 * from the phone, where the officer is, and the portal shows the timeline.
 */
export const visitKeys = {
  byFile: (fileId: string) => ['visits', fileId] as const,
};

export async function listVisits(fileId: string): Promise<VisitDetail[]> {
  const { data } = await api.get<VisitDetail[]>(`/files/${fileId}/visits`);
  return data;
}

export function useVisits(fileId: string) {
  return useQuery({
    queryKey: visitKeys.byFile(fileId),
    queryFn: () => listVisits(fileId),
    enabled: !!fileId,
  });
}

/** Fold one pushed visit into the cached list, newest first. */
export function mergeVisit(list: VisitDetail[] | undefined, visit: VisitDetail): VisitDetail[] {
  const rest = (list ?? []).filter((v) => v.id !== visit.id);
  return [visit, ...rest].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}
